<template>
  <div>
    <el-table
      :data="clients"
      @sort-change="sortChangeHandler"
      @row-click="goToClient"
    >
      <el-table-column label="Nom" min-width="120">
        <template v-if="scope.row.lastName" slot-scope="scope">
          {{ scope.row.lastName }}
        </template>
      </el-table-column>

      <el-table-column label="Prénom" min-width="120">
        <template v-if="scope.row.firstName" slot-scope="scope">
          {{ scope.row.firstName }}
        </template>
      </el-table-column>

      <el-table-column label="Société" min-width="120">
        <template v-if="scope.row.company" slot-scope="scope">
          {{ scope.row.company }}
        </template>
      </el-table-column>

      <el-table-column label="CP" width="80">
        <template v-if="scope.row.zipcode" slot-scope="scope">
          {{ scope.row.zipcode }}
        </template>
      </el-table-column>

      <el-table-column label="Ville" min-width="150">
        <template v-if="scope.row.city" slot-scope="scope">
          {{ scope.row.city }}
        </template>
      </el-table-column>

      <el-table-column
        label="Perdu le"
        sortable="custom"
        prop="lostAt"
        width="120"
      >
        <template v-if="scope.row.lostAt" slot-scope="scope">
          {{ formatDate(scope.row.lostAt) }}
        </template>
      </el-table-column>

      <el-table-column label="Cause perte" prop="lostReason" width="180">
      </el-table-column>

      <el-table-column label="Commercial" width="160">
        <template slot-scope="scope">
          <div
            v-if="scope.row.commercials && scope.row.commercials.length > 0"
            class="d-flex flex-column"
            style="gap: 5px"
          >
            <CommercialRel
              v-for="commercialRel in scope.row.commercials"
              :key="commercialRel.id"
              :relation="commercialRel"
            />
          </div>
        </template>
      </el-table-column>

      <el-table-column label="B2B" prop="isB2B" width="70" align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.isB2B" class="fa fa-check-circle text-info"></i>
        </template>
      </el-table-column>

      <el-table-column label="N° Relance" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.relaunchNumber || "0" }}
        </template>
      </el-table-column>

      <el-table-column label="Relancé le" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.relaunchedAt">
            {{ formatDateTime(scope.row.relaunchedAt) }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="Note" width="225">
        <template slot-scope="scope">
          <NoteModal
            style="margin-top: 1px"
            :notes="
              scope.row.prospect
                ? scope.row.prospect.note
                : scope.row.commercialNotes
            "
            :key="scope.row.id"
            v-if="hasPermission($store.state.user, 'CLIENTS_WRITE')"
            @showComment="showComment(scope.row)"
          />
          <span v-else>
            {{ scope.row.prospect.note }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="Actions" width="170" align="center">
        <template slot-scope="scope">
          <button
            class="btn btn-sm btn-primary"
            @click.stop="handleRelaunch(scope.row)"
            v-if="
              hasPermission($store.state.user, 'CLIENTS_WRITE') &&
              scope.row.relaunchNumber !== 3
            "
          >
            <i class="fa fa-phone mr-05"></i> Relancer
          </button>

          <button
            class="btn btn-sm btn-warning ml-1"
            @click.stop="archive(scope.row)"
            v-if="hasPermission($store.state.user, 'CLIENTS_WRITE')"
          >
            <i class="fa fa-archive"></i>
          </button>
        </template>
      </el-table-column>
    </el-table>

    <paginate
      ref="paginate"
      :value="page"
      :page-count="count"
      :click-handler="paginationHandler"
      prev-text="Précédent"
      next-text="Suivant"
      container-class="pagination"
      class="pt-1"
    ></paginate>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";

import NoteModal from "@/components/form/NoteModal";
import CommercialRel from "@/components/utils/CommercialRel";

export default {
  components: {
    CommercialRel,
    NoteModal,
    Paginate,
  },

  props: {
    clients: {
      type: Array,
      default: () => [],
    },
    totalClients: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 15,
    },
  },

  computed: {
    count() {
      return Math.ceil(this.totalClients / this.limit);
    },
  },

  watch: {
    page() {
      this.$refs.paginate.selected = this.page - 1;
    },
  },

  methods: {
    showComment(client) {
      this.$emit("showComment", client);
    },

    paginationHandler(page) {
      this.$emit("changePage", page);
    },

    handleRelaunch(client) {
      this.$emit("relaunchClient", client);
    },

    archive(client) {
      this.$emit("archiveClient", client);
    },

    sortChangeHandler(sortBy) {
      this.$emit("changeSort", sortBy);
    },

    goToClient(client) {
      const route = this.$router.resolve({
        name: "client-details",
        params: {
          id: client.id,
        },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
